interface ILatLng {
    lat: number;
    lng: number;
}

interface ILatLngBounds {
    southWest: ILatLng;
    northEast: ILatLng;
}

interface IMapBoundsChange {
    bounds: google.maps.LatLngBounds | undefined;
    center: google.maps.LatLng | undefined;
    zoom: number | undefined;
}

function latLngBoundsEqual(
    b1: ILatLngBounds | null,
    b2: ILatLngBounds | null,
    tolerance = 0.0001,
): boolean {
    if (!b1 || !b2) {
        return false;
    }

    const { southWest: sw1, northEast: ne1 } = b1;
    const { southWest: sw2, northEast: ne2 } = b2;

    return (
        Math.abs(sw1.lat - sw2.lat) < tolerance &&
        Math.abs(sw1.lng - sw2.lng) < tolerance &&
        Math.abs(ne1.lat - ne2.lat) < tolerance &&
        Math.abs(ne1.lng - ne2.lng) < tolerance
    );
}

function boundsEqual(
    b1: google.maps.LatLngBounds | null,
    b2: google.maps.LatLngBounds | null,
    tolerance = 0.0001,
): boolean {
    if (!b1 || !b2) {
        return false;
    }

    const ne1 = b1.getNorthEast();
    const sw1 = b1.getSouthWest();
    const ne2 = b2.getNorthEast();
    const sw2 = b2.getSouthWest();

    return (
        Math.abs(ne1.lat() - ne2.lat()) < tolerance &&
        Math.abs(ne1.lng() - ne2.lng()) < tolerance &&
        Math.abs(sw1.lat() - sw2.lat()) < tolerance &&
        Math.abs(sw1.lng() - sw2.lng()) < tolerance
    );
}

function googleMapsBoundsToLatLngBounds(gBounds: google.maps.LatLngBounds | null): ILatLngBounds | null {
    if (!gBounds) {
        return null;
    }

    const ne = gBounds.getNorthEast();
    const sw = gBounds.getSouthWest();

    return {
        southWest: {
            lat: sw.lat(),
            lng: sw.lng(),
        },
        northEast: {
            lat: ne.lat(),
            lng: ne.lng(),
        },
    };
}

function stripParentheses(value: string | null | undefined): string | null | undefined {
    return value?.replace(/\s*\(.*\)/g, '')
        .trim() ?? value;
}

export {
    latLngBoundsEqual,
    boundsEqual,
    googleMapsBoundsToLatLngBounds,
    stripParentheses,
};
export type {
    ILatLng,
    ILatLngBounds,
    IMapBoundsChange,
};
